import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dayjs } from 'dayjs'

export type HepatitisInfoWithConcentDate = {
  consentDate: Dayjs;
};

export type HepatitisInfoWithoutConcentDate = {
  id?: number
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  birthCertificate: string
  otherDocument: string
  relativeTypeId: string
  receiptDate: string
  slipNo?: string
  claimName: string
  receiptNo: string
  remark?: string
};

export type HepatitisInf = {
  claimInfo: HepatitisInfoWithConcentDate | HepatitisInfoWithoutConcentDate
}

export const initState: HepatitisInf = {
  claimInfo: {
    name: '',
    amountReceipt: 0,
    amountClaim: 0,
    receiptFile: '',
    optionalFileUrl: '',
    birthCertificate: '',
    otherDocument: '',
    relativeTypeId: '',
    receiptDate: '',
    claimName: '',
    receiptNo: '',
    remark: '',
  },
}

const hepatitisSlice = createSlice({
  name: 'hepatitis',
  initialState: initState,
  reducers: {
    setHepatitisInfo: (state, { payload }: PayloadAction<HepatitisInf['claimInfo']>) => {
      state.claimInfo = payload
    },
    clearHepatitisInfo: (state) => {
      state.claimInfo = initState.claimInfo
    },
  },
})

export const hepatitisReducer = hepatitisSlice.reducer

export const { setHepatitisInfo, clearHepatitisInfo } = hepatitisSlice.actions
